import { render, staticRenderFns } from "./PaymentTypeDisplay.vue?vue&type=template&id=55a89dee"
import script from "./PaymentTypeDisplay.vue?vue&type=script&lang=js"
export * from "./PaymentTypeDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports